import styled from 'styled-components/macro';

import modularScale from '../../../styles/helpers/modular-scale';
import { StyledDiv } from 'components/base/AnimatedLoadingWrapper';
import { ThemeProps } from 'types/styled';

export const HeaderContainer = styled(StyledDiv)`
  display: flex;
  align-items: center;
  transition: ${({ theme }): string =>
    `opacity ${theme.transitionDuration} ${theme.timingFunction}`};
  opacity: ${({ loading }): number => (loading ? 0 : 1)};
`;

export const ArtworkPositioner = styled('div')`
  flex-shrink: 0;

  @media screen and (min-width: 40em) {
    margin-top: ${({ theme }): string => theme.spacing.xxsmall};
    margin-right: ${({ theme }): string => theme.spacing.medium};
  }
`;

export const EntityType = styled('span')`
  color: white;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.1em;
  white-space: nowrap;
`;

export const EntityTitle = styled.h1<ThemeProps<'h1'>>`
  color: white;
  font-size: ${({ fontSize = 2 }): string => modularScale(fontSize)};
  font-weight: 600;
  line-height: 1.25;
  min-height: 1.25em; /* font-size * line-height */
  hyphens: auto;
  margin-bottom: 0.2em;

  @media screen and (min-width: 40em) {
    font-size: ${({ fontSize = 5 }): string => modularScale(fontSize)};
    margin-bottom: 0;
  }
`;

export const Header = styled('header')`
  display: flex;
  flex-direction: column;
  min-width: 100%;
  align-items: center;
  text-align: center;
  padding: 0 0 ${({ theme }): string => theme.spacing.xlarge} 0;

  @media screen and (min-width: 40em) {
    text-align: left;
    flex-flow: row nowrap;
    align-items: flex-start;
    justify-content: center;
  }
`;

export const ContentWrapper = styled('div')`
  width: 100%;

  @media screen and (min-width: 40em) {
    width: auto;
  }
`;

export const FollowEntityButtonWrapper = styled('div')`
  display: inline-block;
`;

export const FollowersButton = styled('div')`
  color: #ffffff;
  font-size: 13px;
  margin-bottom: 10px;
`;

export const ReleaseTypeWrapper = styled('span')`
  &:before {
    font-size: 16px;
    content: '•';
    margin: 0 7px;
  }
`;
